import ArgumentInterface from "./ArgumentInterface.ts";

export default class Argument implements ArgumentInterface {
    name: String;
    type: String;
    required: Boolean;

    /**
     *
     * @param name
     * @param type
     * @param required
     */
    constructor(name: String, type: String, required: Boolean) {
        this.name = name;
        this.type = type;
        this.required = required;
    }

    getName(): String {
        return this.name;
    }

    getType(): String {
        return this.type;
    }

    /**
     * @param type
     */
    setType(type: String): ArgumentInterface {
        this.type = type;

        return this;
    }

    getRequired(): Boolean {
        return this.required;
    }

}


// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/Argument.ts